export default __webpack_public_path__ + "static/media/icon.8f20c5cf.svg";